import {
  IconList,
  IconPhone,
  IconPlayerPlay,
  IconRefresh,
  IconServer,
  IconSettings
} from '@tabler/icons-react';

const profileServices = [
  { title: 'Polling', url: '/services/polling', icon: IconRefresh },
  { title: 'Work Order Lists', url: '/services/workorder_lists', icon: IconList },
  { title: 'Counter Presets', url: '/services/counter_presets', icon: IconSettings },
  { title: 'Automation', url: '/services/automation', icon: IconPlayerPlay },
  { title: 'QuickBooks', url: '/services/quickbooks', icon: IconServer },
  { title: 'Contact Directory', url: '/services/contact_directory', icon: IconPhone },
  { title: 'Node Management', url: '/services/node', icon: IconServer }
];

export default profileServices;
